/* One finite illustration entrance; content is visible without JavaScript. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reduceMotion.matches) entry.target.classList.add('ln-scene-seen');
      observer.unobserve(entry.target);
    });
  }, {threshold: .2});
  const init = scope => scope.querySelectorAll('.ln-service-scene:not([data-ln-scene])').forEach(scene => {
    scene.dataset.lnScene = 'ready';
    observer.observe(scene);
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
